export const PREFIX = ""
export const API = 'https://api.cloud.bodyhealthanalyzer.com'
export const SYNC_TARGET_API = 'https://cloud.stressrecoveryanalyzer.com'
export const SETTING = {
  "title": "Body Health Analyzer Cloud Administrator Console",
}
